import type { CollectionFaq } from '$lib/storyblok/types';

export const extractRawLdJsonScript = (items?: CollectionFaq[]) => {
	if (!items) {
		return '';
	}

	const baseScript = `<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
  	${items.map((item) => {
			return `{
			"@type": "Question",
			"name": "${item.question}",
			"acceptedAnswer": {
				"@type": "Answer",
				"text": "${item.answer}"
			}
		}`;
		})}
  ]
}
</script>`;

	return baseScript;
};
